import { Dialog, ButtonCallbacks } from '@/components/types/Dialog';

export const changeAccountDialog: Dialog = {
  title: 'app.changeAccount',
  maxWidth: '750px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'common.cancel',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.SAVE,
      text: 'app.changeAccount'
    }
  ]
};

export const feedbackDialog: Dialog = {
  title: 'app.feedbackTitle',
  maxWidth: '750px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'common.cancel',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.SAVE,
      text: 'administration.transmit'
    }
  ]
};

export const changePasswordDialog: Dialog = {
  title: 'settings.changePassword',
  maxWidth: '600px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'common.cancel',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.SAVE,
      text: 'common.save'
    }
  ]
};
